const Spacer = ({ space = '1rem' }) => <div style={{ marginBottom: space }}></div>;

const Spaced = ({ children, space = '1rem' }) => {
    return <div style={{ marginBottom: space, marginTop: space }}>
        {children}
    </div>
}

export { 
    Spaced
}

export default Spacer;